<template>
    <div class="modal-mask modal-container" v-if="noticeDataList.length > 0 && popupState">
      <div class="popup-event-wrap">
        <div class="swiper-container popup-event-slider">
          <swiper class="swiper-wrapper" :options="swiperOptions" :key="'noticePopup'">
            <swiper-slide v-for="(notice, index) in noticeDataList" :key="'notice_popup_' + index" class="swiper-slide">
              <a @click.prevent.once="()=>moveUrl(notice.bottom_link)" :target="bottomTarget(notice)">
                <img :src="getImage(notice.bottom_img)" alt=""/>
              </a>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination" id="notice-swiper-pagination"></div>
        </div>

        <div class="popup-event-bottom">
          <div class="check-style">
            <input v-model="dayClose" type="checkbox" id="ch-today" class="check-purple-round"><label for="ch-today">일주일 동안 보지 않기</label>
          </div>
          <button @click="closePopup()" class="close-event-popup">닫기</button>
        </div>
      </div>
    </div>
</template>

<script>
import utils from '@/common/util/utils'
import {
  MOBILE_WEB_HOSTNAME,
  PC_WEB_HOSTNAME,
  SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY,
  URL_COOKIE_DOMAIN
} from '@/common/constant'
import { NoticePopupService } from '@/common/api/api.service'
import { get } from 'lodash'
import { getSessionStorage } from '@/common/util/storage.util'
import { disableBodyScroll, enableBodyScroll } from '@/common/util/ui.utils'
import { bannerLink } from '@/common/util/common'
import { resizeThumbnail } from '@/common/image.filter'
export default {
  name: 'NoticePopup',
  props: {
    closePopupFn: {
      type: Function
    },
    openPopupFn: {
      type: Function
    },
    showNoticePopup: {
      type: Boolean
    }
  },
  data () {
    return {
      dayClose: false,
      device: utils.cookies.getDevice(),
      swiperOptions: {
        pagination: {
          el: '#notice-swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        slidesPerView: 'auto',
        spaceBetween: 15
      },
      noticeDataList: [],
      popupState: true,
      isLoading: true
    }
  },
  methods: {
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: '20', quality: 80 })
    },
    closePopup () {
      if (this.dayClose) {
        let expires = new Date()
        expires.setDate(expires.getDate() + 7)
        utils.cookies.setItem('close-popup', '1', expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
      }
      this.closePopupFn()
      this.noticeDataList = []
      enableBodyScroll()
    },
    bottomTarget (notice) {
      let link = get(notice, ['top_list', '0', 'bottom_list', '0', 'bottom_link'], '')
      if (link.indexOf(PC_WEB_HOSTNAME) >= 0) return '_self'
      else if (link.indexOf('wavve.com') >= 0) return '_blank'
      else return '_blank'
    },
    moveUrl (url) {
      const bannerUrl = process.env.NODE_ENV === 'production' ? url : url.replace(MOBILE_WEB_HOSTNAME, `${location.origin}`)
      bannerLink(bannerUrl)
    }
  },
  created () {
    NoticePopupService.getNoticeBanner({ bannerid: 'layerpopup' }).then(({ data }) => {
      const bottomList = get(data, ['top_list', '0', 'bottom_list'], [])
      if (bottomList.length === 0 || this.showNoticePopup) {
        this.closePopupFn()
      } else {
        this.noticeDataList = bottomList
        this.noticeDataList.map((data) => {
          const includeHtmlPostfixList = ['m.wavve.com/event/partners/index.html']
          if (includeHtmlPostfixList.indexOf(data.bottom_link) < 0) {
            data.bottom_link = data.bottom_link.indexOf('.html') > -1 ? data.bottom_link.replace('.html', '') : data.bottom_link
          }
        })

        if (utils.cookies.getItem('close-popup') !== '1' && bottomList.length > 0) {
          if (getSessionStorage().get(SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY) !== 'y') {
            this.openPopupFn()
          }
        } else {
          this.popupState = false
        }
        if (this.noticeDataList.length > 0 && this.popupState) {
          disableBodyScroll()
        }
      }
    })
  }
}
</script>
<style scoped>
  .modal-container {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.8);
    -webkit-transition: opacity .3s ease;
    transition: opacity .3s ease;
    overflow-y: scroll;
  }

  /*
    .popup-event-wrap{
      width: 65%;
      max-width: 330px;
      margin: 20% auto;
      border-radius: 8px;
      overflow: hidden;
      background-color: #fff;
    }
    @media screen and (min-width: 768px){
      .modal-container {
        overflow: hidden;
      }
      .popup-event-wrap{
        position: absolute;
        width: 330px;
        top: 50%;
        margin-top: -250px;
        left: 50%;
        margin-left: -165px;
      }
    }
   */

   .popup-event-wrap{
     position: absolute;
     width: 260px;
     top: 50%;
     margin-top: -202px;
     left: 50%;
     margin-left: -130px;
   }

   @media screen and (min-width: 360px){
     .popup-event-wrap{
       width: 315px;
       margin-top: -240px;
       margin-left: -157px;
     }
   }
   @media screen and (min-width: 768px){
     .popup-event-wrap{
       width: 330px;
       margin-top: -250px;
       margin-left: -165px;
     }
   }

  .popup-event-slider .swiper-slide img{
    width: 100%;
  }
  .swiper-pagination{
    position: absolute;
    width:100%;
    bottom: 0;
  }
  .popup-event-bottom{
    background: #252525;
    padding: 14px 20px;
  }

  .popup-event-bottom:after{
    content: "";
    display: block;
    clear: both;
  }

  .popup-event-bottom .check-style{
    float: left;
    display: inline-block;
  }
  .popup-event-bottom .check-style input[type=checkbox]+label{
    font-size: 14px;
    color: #a5a5a5;
  }
  .popup-event-bottom .check-style input[type="checkbox"].check-purple-round:focus + label:before{
    border: 1px #d9d9d9 solid;
  }
  .popup-event-bottom .check-style input[type="checkbox"].check-purple-round:checked + label:before{
    border: 1px solid #1351f9;
  }
  .close-event-popup{
    float: right;
    font-size: 14px;
    color: #a5a5a5;
    height: 24px;
  }
  .check-style input[type=checkbox] {
    position: absolute;
    clip: rect(0,0,0,0);
  }
  .check-style input[type=checkbox]+label {
    position: relative;
    font-size: 13px;
    letter-spacing: -.2px;
    color: #23212a;
  }
  /*보라색 체크박스- 원형*/
  .check-style input[type=checkbox].check-purple-round+label:before {
    border-radius: 100px;
    border: 1px solid #d9d9d9;
    vertical-align: middle;
  }

  .check-style input[type=checkbox]+label:before {
    content: " ";
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }
  .check-style input[type="checkbox"].check-purple-round + label:before{
    border-radius: 100px;
    border: 1px solid #d9d9d9;
    vertical-align: middle;
  }
  .check-style input[type="checkbox"].check-purple-round:focus + label:before{
    border: 1px solid #1351f9;
  }
  .check-style input[type="checkbox"].check-purple-round:checked + label:before{
    background: url(/img/common/check-purple.png) #1351f9 no-repeat center;
    background-size: 22px;
    border: 1px solid #1351f9;
  }
</style>
